import {grid} from '~/design-system/foundations'
import HgAccordionBase from './components/HgAccordionBase'
import {type HgAccordionBaseProps} from './components/HgAccordionBase/types'

export default function HgAccordion({items}: HgAccordionBaseProps) {
  return (
    <div className="w-full pt-s9">
      <div className={grid({className: 'mx-auto'})}>
        <HgAccordionBase items={items} />
      </div>
    </div>
  )
}
